export function isTextEditingTarget(target) {
  if (!target) {
    return false;
  }

  if (target.isContentEditable) {
    return true;
  }

  if (typeof target.closest === "function" && target.closest('[contenteditable="true"]')) {
    return true;
  }

  const tagName = typeof target.tagName === "string" ? target.tagName.toLowerCase() : "";
  return tagName === "input" || tagName === "textarea" || tagName === "select";
}

export function shouldIgnoreShortcut(event) {
  return !!(event?.defaultPrevented || isTextEditingTarget(event?.target));
}
